import React from 'react';
import { pick } from 'ramda';
import { getURLParam } from '@theme/js/utils/url.util';
import { WebContent } from '@core/js/components/system/WebContent';
import { useAppSelector, useDeviceSelector, usePageSelector } from '@core/js/store/hooks';

import style from './AboveHeader.scss';

export const AboveHeader = () => {
    const { aboveHeaderWcIdDesktop, aboveHeaderWcIdTablet, aboveHeaderWcIdMobile } = useAppSelector();

    /* Lugano changes */
    const { isMobile, formFactor } = useDeviceSelector(pick(['isMobile', 'formFactor']));
    const { headerWcId, overrideHeader } = usePageSelector(pick(['headerWcId', 'overrideHeader']));
    const hideHeaderByUrl = getURLParam(location.search, 'hideHeader') === '1';
    const hideDesktopHeaderByUrl = getURLParam(location.search, 'showHeaderOnlyOnMobile') === '1';
    const hideHeader = hideHeaderByUrl || hideDesktopHeaderByUrl && !isMobile || overrideHeader && !headerWcId;
    /* Lugano changes */

    const wcID = {
        desktop: aboveHeaderWcIdDesktop,
        tablet: aboveHeaderWcIdTablet,
        mobile: aboveHeaderWcIdMobile
    }[formFactor];

    if (wcID) {
        return (
            <div className={`${style.container} ${hideHeader ? style.withOutHeader : ''} cms-above-header`} /* Lugano changes */
            >
                <WebContent id={wcID} />
            </div>
        );
    }

    return null;
};
